import { render, staticRenderFns } from "./ConfigSchedulePermission.vue?vue&type=template&id=8f83340c"
import script from "./ConfigSchedulePermission.vue?vue&type=script&lang=js"
export * from "./ConfigSchedulePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports